module.exports = __webpack_public_path__ + "static/media/facultaGeogra.d5421ae9.png";